"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  common: {
    ok: 'OK',
    error: 'Erreur',
    errorTitle: 'Erreur',
    success: 'Succès',
    unexpectedError: "Désolé, une erreur inattendue s'est produite. Veuillez réessayer plus tard."
  },
  imageDocumentPreview: {
    error: "Aperçu de l'image non disponible"
  },
  pdfDocumentPreview: {
    pdfError: 'Aperçu du PDF non disponible',
    empty: "Il n'y a aucun fichier"
  },
  date: {
    rangeFilterName: 'Plage de dates',
    any: 'Tout le temps',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    rangeSeparator: 'à',
    placeholder: 'Date',
    presets: {
      today: "Aujourd'hui",
      thisWeek: 'Cette semaine',
      lastWeek: 'La semaine dernière',
      thisMonth: 'Ce mois-ci',
      lastMonth: 'Le mois dernier'
    }
  },
  tableFooter: {
    showing: 'Affichage de {{pageStart}} à {{pageEnd}} de {{totalItemsCount}} {{dataName}}',
    mobileShowing: 'Affichage de {{pageStart}} à {{pageEnd}} {{dataName}}'
  },
  emailBox: {
    emailInvoice: 'Envoyez-nous votre facture par e-mail (les fournisseurs peuvent également utiliser ceci):',
    emailSupliersCompleteData: 'Envoyez aux fournisseurs un lien pour compléter leurs données:',
    emailSupliersSendQuote: 'Envoyez aux fournisseurs un lien pour envoyer un devis:',
    copied: 'Copié !'
  },
  amountCell: {
    converted: 'Converti :'
  },
  addFiltersToggle: {
    add: 'Ajouter des filtres'
  },
  filtersLayout: {
    search: 'Recherche...'
  },
  settingsLayout: {
    title: 'Paramètres'
  },
  reportsLayout: {
    title: 'Rapports'
  },
  additionalFiltersLayout: {
    filterBy: 'Filtrer par',
    apply: 'Appliquer les filtres',
    clear: 'Effacer les filtres'
  },
  fileUploader: {
    buttonText: 'Téléverser un fichier',
    fileSizeError: 'La taille du fichier ne peut pas dépasser {{maxSizeMb}} Mo.',
    defaultEmptyText: 'Aucun fichier sélectionné'
  },
  fileDropZone: {
    remove: 'Supprimer',
    browse: 'ou parcourir ici'
  },
  statusLabel: {
    approved: 'APPROUVÉ',
    pending: 'EN ATTENTE',
    awaitingApproval: "EN ATTENTE D'APPROBATION",
    notSubmitted: 'NON SOUMIS',
    draft: 'BOUCHON',
    cancelled: 'ANNULÉ',
    declined: 'DÉCLINÉ',
    completed: 'TERMINÉ'
  },
  errors: {
    pageNotFound: 'Cette page est introuvable.',
    unexpectedError: "Quelque chose s'est mal passé. Veuillez contacter le support.",
    returnToLogin: 'Retour à la connexion',
    error: 'Erreur',
    uiSettingsIssue: "Il y a un problème dans les paramètres de l'interface utilisateur."
  },
  inputPassword: {
    hide: 'Cacher',
    show: 'Afficher'
  },
  inputAmount: {
    popularGroup: 'Populaire',
    otherGroup: 'Autre'
  },
  phonePicker: {
    searchPlaceholder: 'Tapez pour rechercher...',
    noCountriesText: 'Aucun pays trouvé'
  },
  multiPhonePicker: {
    addNewLabel: 'Ajouter un numéro de téléphone supplémentaire'
  },
  formField: {
    optional: '(Facultatif)'
  },
  dateCell: {
    futurePayment: 'Paiement futur'
  },
  multiSearchSelect: {
    all: 'Tout',
    selectAll: 'Sélectionner tout',
    deselectAll: 'Désélectionner tout',
    noOptions: 'Aucune option trouvée'
  },
  currencies: {
    AED: 'Dirham des Émirats arabes unis',
    AFN: 'Afghani afghan',
    ALL: 'Lek albanais',
    AMD: 'Dram arménien',
    ANG: 'Florin antillais néerlandais',
    AOA: 'Kwanza angolais',
    ARS: 'Peso argentin',
    AUD: 'Dollar australien',
    AWG: 'Florin arubais',
    AZN: 'Manat azéri',
    BAM: 'Mark convertible de Bosnie-Herzégovine',
    BBD: 'Dollar barbadien',
    BDT: 'Taka bangladais',
    BGN: 'Lev bulgare',
    BHD: 'Dinar bahreïni',
    BIF: 'Franc burundais',
    BMD: 'Dollar bermudien',
    BND: 'Dollar de Brunei',
    BOB: 'Boliviano',
    BRL: 'Real brésilien',
    BSD: 'Dollar bahaméen',
    BTN: 'Ngultrum bhoutanais',
    BWP: 'Pula botswanais',
    BYN: 'Rouble biélorusse',
    BZD: 'Dollar bélizien',
    CAD: 'Dollar canadien',
    CDF: 'Franc congolais',
    CHF: 'Franc suisse',
    CLP: 'Peso chilien',
    CNY: 'Yuan chinois',
    COP: 'Peso colombien',
    CRC: 'Colon costaricain',
    CUC: 'Peso cubain convertible',
    CVE: 'Escudo cap-verdien',
    CZK: 'Couronne tchèque',
    DJF: 'Franc djiboutien',
    DKK: 'Couronne danoise',
    DOP: 'Peso dominicain',
    DZD: 'Dinar algérien',
    EGP: 'Livre égyptienne',
    ERN: 'Nakfa érythréen',
    ETB: 'Birr éthiopien',
    EUR: 'Euro',
    FJD: 'Dollar fidjien',
    FKP: 'Livre des îles Falkland',
    GBP: 'Livre sterling',
    GEL: 'Lari géorgien',
    GHS: 'Cedi ghanéen',
    GIP: 'Livre de Gibraltar',
    GMD: 'Dalasi gambien',
    GNF: 'Franc guinéen',
    GTQ: 'Quetzal guatémaltèque',
    GYD: 'Dollar guyanais',
    HKD: 'Dollar de Hong Kong',
    HNL: 'Lempira hondurien',
    HRK: 'Kuna croate',
    HTG: 'Gourde haïtienne',
    HUF: 'Forint hongrois',
    IDR: 'Roupie indonésienne',
    ILS: 'Nouveau shekel israélien',
    INR: 'Roupie indienne',
    IQD: 'Dinar irakien',
    IRR: 'Rial iranien',
    ISK: 'Couronne islandaise',
    JMD: 'Dollar jamaïcain',
    JOD: 'Dinar jordanien',
    JPY: 'Yen japonais',
    KES: 'Shilling kényan',
    KGS: 'Som kirghize',
    KHR: 'Riel cambodgien',
    KMF: 'Franc comorien',
    KPW: 'Won nord-coréen',
    KRW: 'Won sud-coréen',
    KWD: 'Dinar koweïtien',
    KYD: 'Dollar des îles Caïmans',
    KZT: 'Tenge kazakh',
    LAK: 'Kip laotien',
    LBP: 'Livre libanaise',
    LKR: 'Roupie srilankaise',
    LRD: 'Dollar libérien',
    LSL: 'Loti lesothan',
    LYD: 'Dinar libyen',
    MAD: 'Dirham marocain',
    MDL: 'Leu moldave',
    MGA: 'Ariary malgache',
    MKD: 'Dinar macédonien',
    MMK: 'Kyat birman',
    MNT: 'Tugrik mongol',
    MOP: 'Pataca macanais',
    MRO: 'Ouguiya mauritanien',
    MUR: 'Roupie mauricienne',
    MVR: 'Rufiyaa maldivienne',
    MWK: 'Kwacha malawien',
    MXN: 'Peso mexicain',
    MYR: 'Ringgit malaisien',
    MZN: 'Metical mozambicain',
    NAD: 'Dollar namibien',
    NGN: 'Naira nigérian',
    NIO: 'Cordoba nicaraguayen',
    NOK: 'Couronne norvégienne',
    NPR: 'Roupie népalaise',
    NZD: 'Dollar néo-zélandais',
    OMR: 'Rial omanais',
    PAB: 'Balboa panaméen',
    PEN: 'Sol péruvien',
    PGK: 'Kina papouan-néo-guinéen',
    PHP: 'Peso philippin',
    PKR: 'Roupie pakistanaise',
    PLN: 'Zloty polonais',
    PYG: 'Guarani paraguayen',
    QAR: 'Riyal qatari',
    RON: 'Leu roumain',
    RSD: 'Dinar serbe',
    RUB: 'Rouble russe',
    RWF: 'Franc rwandais',
    SAR: 'Riyal saoudien',
    SBD: 'Dollar des îles Salomon',
    SCR: 'Roupie des Seychelles',
    SDG: 'Livre soudanaise',
    SEK: 'Couronne suédoise',
    SGD: 'Dollar singapourien',
    SHP: 'Livre de Sainte-Hélène',
    SLL: 'Leone sierra-léonais',
    SOS: 'Shilling somalien',
    SRD: 'Dollar surinamais',
    SSP: 'Livre sud-soudanaise',
    STD: 'Dobra santoméen',
    SVC: 'Colón salvadorien',
    SYP: 'Livre syrienne',
    SZL: 'Lilangeni swazi',
    THB: 'Baht thaïlandais',
    TJS: 'Somoni tadjik',
    TMT: 'Manat turkmène',
    TND: 'Dinar tunisien',
    TOP: "Pa'anga tongien",
    TRY: 'Livre turque',
    TTD: 'Dollar de Trinité-et-Tobago',
    TWD: 'Dollar taïwanais',
    TZS: 'Shilling tanzanien',
    UAH: 'Hryvnia ukrainienne',
    UGX: 'Shilling ougandais',
    USD: 'Dollar américain',
    UYU: 'Peso uruguayen',
    UZS: 'Som ouzbek',
    VEF: 'Bolivar vénézuélien',
    VND: 'Dong vietnamien',
    VUV: 'Vatu vanuatuan',
    WST: 'Tala samoan',
    YER: 'Rial yéménite',
    ZAR: 'Rand sud-africain',
    ZMW: 'Kwacha zambien',
    ZWL: 'Dollar zimbabwéen'
  },
  countries: {
    AF: 'Afghanistan',
    AX: 'Îles Åland',
    AL: 'Albanie',
    DZ: 'Algérie',
    AS: 'Samoa américaines',
    AD: 'Andorre',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctique',
    AG: 'Antigua-et-Barbuda',
    AR: 'Argentine',
    AM: 'Arménie',
    AW: 'Aruba',
    AU: 'Australie',
    AT: 'Autriche',
    AZ: 'Azerbaïdjan',
    BS: 'Bahamas',
    BH: 'Bahreïn',
    BD: 'Bangladesh',
    BB: 'Barbade',
    BY: 'Biélorussie',
    BE: 'Belgique',
    BZ: 'Belize',
    BJ: 'Bénin',
    BM: 'Bermudes',
    BT: 'Bhoutan',
    BO: 'Bolivie, État plurinational de',
    BQ: 'Bonaire, Saint-Eustache et Saba',
    BA: 'Bosnie-Herzégovine',
    BW: 'Botswana',
    BV: 'Île Bouvet',
    BR: 'Brésil',
    IO: 'Territoire britannique de l’océan Indien',
    BN: 'Brunéi Darussalam',
    BG: 'Bulgarie',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodge',
    CM: 'Cameroun',
    CA: 'Canada',
    CV: 'Cap-Vert',
    KY: 'Îles Caïmans',
    CF: 'République centrafricaine',
    TD: 'Tchad',
    CL: 'Chili',
    CN: 'Chine',
    CX: 'Île Christmas',
    CC: 'Îles Cocos (Keeling)',
    CO: 'Colombie',
    KM: 'Comores',
    CG: 'Congo',
    CD: 'Congo, République démocratique du',
    CK: 'Îles Cook',
    CR: 'Costa Rica',
    CI: "Côte d'Ivoire",
    HR: 'Croatie',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Chypre',
    CZ: 'République tchèque',
    DK: 'Danemark',
    DJ: 'Djibouti',
    DM: 'Dominique',
    DO: 'République dominicaine',
    EC: 'Équateur',
    EG: 'Égypte',
    SV: 'El Salvador',
    GQ: 'Guinée équatoriale',
    ER: 'Érythrée',
    EE: 'Estonie',
    ET: 'Éthiopie',
    FK: 'Îles Malouines (Falkland)',
    FO: 'Îles Féroé',
    FJ: 'Fidji',
    FI: 'Finlande',
    FR: 'France',
    GF: 'Guyane française',
    PF: 'Polynésie française',
    TF: 'Terres australes françaises',
    GA: 'Gabon',
    GM: 'Gambie',
    GE: 'Géorgie',
    DE: 'Allemagne',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grèce',
    GL: 'Groenland',
    GD: 'Grenade',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernesey',
    GN: 'Guinée',
    GW: 'Guinée-Bissau',
    GY: 'Guyana',
    HT: 'Haïti',
    HM: 'Îles Heard et MacDonald',
    VA: 'Saint-Siège (État de la Cité du Vatican)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hongrie',
    IS: 'Islande',
    IN: 'Inde',
    ID: 'Indonésie',
    IR: 'Iran, République islamique d’',
    IQ: 'Irak',
    IE: 'Irlande',
    IM: 'Île de Man',
    IL: 'Israël',
    IT: 'Italie',
    JM: 'Jamaïque',
    JP: 'Japon',
    JE: 'Jersey',
    JO: 'Jordanie',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Corée, République populaire démocratique de',
    KR: 'Corée, République de',
    KW: 'Koweït',
    KG: 'Kirghizistan',
    LA: 'République démocratique populaire lao',
    LV: 'Lettonie',
    LB: 'Liban',
    LS: 'Lesotho',
    LR: 'Libéria',
    LY: 'Libye',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macédoine, l’ex-République yougoslave de',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaisie',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malte',
    MH: 'Îles Marshall',
    MQ: 'Martinique',
    MR: 'Mauritanie',
    MU: 'Maurice',
    YT: 'Mayotte',
    MX: 'Mexique',
    FM: 'Micronésie, États fédérés de',
    MD: 'Moldavie, République de',
    MC: 'Monaco',
    MN: 'Mongolie',
    ME: 'Monténégro',
    MS: 'Montserrat',
    MA: 'Maroc',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibie',
    NR: 'Nauru',
    NP: 'Népal',
    NL: 'Pays-Bas',
    NC: 'Nouvelle-Calédonie',
    NZ: 'Nouvelle-Zélande',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigéria',
    NU: 'Niue',
    NF: 'Île Norfolk',
    MP: 'Îles Mariannes du Nord',
    NO: 'Norvège',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palaos',
    PS: 'Palestine, État de',
    PA: 'Panama',
    PG: 'Papouasie-Nouvelle-Guinée',
    PY: 'Paraguay',
    PE: 'Pérou',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Pologne',
    PT: 'Portugal',
    PR: 'Porto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roumanie',
    RU: 'Fédération de Russie',
    RW: 'Rwanda',
    BL: 'Saint-Barthélemy',
    SH: 'Sainte-Hélène, Ascension et Tristan da Cunha',
    KN: 'Saint-Kitts-et-Nevis',
    LC: 'Sainte-Lucie',
    MF: 'Saint-Martin (partie française)',
    PM: 'Saint-Pierre-et-Miquelon',
    VC: 'Saint-Vincent-et-les-Grenadines',
    WS: 'Samoa',
    SM: 'Saint-Marin',
    ST: 'Sao Tomé-et-Principe',
    SA: 'Arabie saoudite',
    SN: 'Sénégal',
    RS: 'Serbie',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapour',
    SX: 'Saint-Martin (partie néerlandaise)',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    SB: 'Îles Salomon',
    SO: 'Somalie',
    ZA: 'Afrique du Sud',
    GS: 'Géorgie du Sud et les îles Sandwich du Sud',
    SS: 'Soudan du Sud',
    ES: 'Espagne',
    LK: 'Sri Lanka',
    SD: 'Soudan',
    SR: 'Suriname',
    SJ: 'Svalbard et Jan Mayen',
    SZ: 'Eswatini',
    SE: 'Suède',
    CH: 'Suisse',
    SY: 'République arabe syrienne',
    TW: 'Taïwan, Province de Chine',
    TJ: 'Tadjikistan',
    TZ: 'Tanzanie, République-Unie de',
    TH: 'Thaïlande',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinité-et-Tobago',
    TN: 'Tunisie',
    TR: 'Turquie',
    TM: 'Turkménistan',
    TC: 'Îles Turques-et-Caïques',
    TV: 'Tuvalu',
    UG: 'Ouganda',
    UA: 'Ukraine',
    AE: 'Émirats arabes unis',
    GB: 'Royaume-Uni',
    US: 'États-Unis',
    UM: 'Îles mineures éloignées des États-Unis',
    UY: 'Uruguay',
    UZ: 'Ouzbékistan',
    VU: 'Vanuatu',
    VE: 'Venezuela, République bolivarienne du',
    VN: 'Viet Nam',
    VG: 'Îles Vierges britanniques',
    VI: 'Îles Vierges des États-Unis',
    WF: 'Wallis-et-Futuna',
    EH: 'Sahara occidental',
    YE: 'Yémen',
    ZM: 'Zambie',
    ZW: 'Zimbabwe'
  },
  states: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  inlineEdit: {
    save: 'Enregistrer',
    cancel: 'Annuler'
  },
  formPageLayout: {
    discard: 'Annuler et retourner'
  },
  multiSelect: {
    clearAll: 'Tout effacer'
  },
  filterMultiSelect: {
    andMore: 'et {{count}} de plus'
  },
  inlineEditTrigger: {
    edit: 'Éditer'
  },
  searchSelect: {
    noOptions: 'Aucune option'
  },
  cardDetails: {
    title: 'Détails de la carte : x{{lastDigits}}',
    detailsHeader: 'Détails de la carte',
    data: {
      number: 'Numéro de carte',
      holder: 'Titulaire de la carte',
      expiryDate: 'Date dexpiration'
    },
    billingInformation: 'Informations de facturation',
    billingAddress: 'Adresse de facturation',
    vatNumber: 'Numéro de TVA',
    closeCardDetails: 'Fermer les détails de la carte',
    copyNumber: 'Copier le numéro',
    copied: 'Copié'
  },
  addressPicker: {
    enterAddressManually: 'Vous ne trouvez pas votre adresse ? Entrez-la manuellement'
  },
  panelDocumentInfo: {
    download: 'Télécharger',
    noDocument: 'Document non téléchargé'
  },
  accountBalances: {
    availableBalance: 'Solde disponible'
  },
  payAccountlayout: {
    loading: 'Chargement...',
    select: 'Sélectionner'
  }
};
exports.default = _default;